import { transactionDateStore } from "hooks";

export const categoryReportFilterState = (venue) => {
  const { venueId, startDate, endDate } = transactionDateStore(venue);
  return {
    venueId,
    page: 1,
    pageSize: 20,
    searchKey: "",
    dateRange: [startDate, endDate],
    locations: [],
    staffs: [],
    category: null,
    sort: { key: "sale", value: "desc" },
  };
};
